import React, {useEffect, useRef,useState } from "react"; 
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import  {getSubjects} from "../../../../Services/Subjects/SubjectServices"
import  {getCategories,getgames,deleteReview} from "../../../../Services/gameServices"
import { toast } from 'react-toastify';
import { handleFileValidation } from "../../../../utils/Api";
import {createBanner,getBannerDetails,updateBanner} from "../../../../Services/marketingBannersServices"
const CreateBanner = ({popupType,bannerId,reRender, isShow,close }) => {  
  const handleShow = () => setShow(true);
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [subjectData, setSubjectData]    = useState([]);
  const [categoryData, setCategoryData]  = useState([]);
  const [gameData, setGameData]       = useState([]);
  const [subjectId, setSubjectId]     = useState('');
  const [categoryId, setCategoryId]   = useState('');
  const [gameId, setGameId]           = useState('');  
  const [asset,setAsset]              = useState(null)
  const [description, setDescription]           = useState('');  
  const [campaignType, setCampaignType]           = useState('');   
  const [assetError, setAssetError]                 = useState(false);
  const [subjectIdError, setSubjectIdError]     = useState(false);
  const [categoryIdError, setCategoryIdError]   = useState(false);
  const [gameIdError, setGameIdError]           = useState(false);  
  const [descriptionError, setDescriptionError]           = useState(false);  
  const [campaignTypeError, setCampaignTypeError]           = useState(false);
  const [categoryName, setCategoryName] = useState("");

  const [isLoading, setIsloading] = useState(false);
  useEffect(() => {
        setShow(isShow)
        if(popupType=="EDIT"){
          getBannerDetails(bannerId).then((data)=>{
            if(data.status){
             let bannerData=data.data;
             setCampaignType(bannerData?.campaign_type)
             setDescription(bannerData?.description)
             setGameId(bannerData?.game_id) 
             setCategoryId(bannerData?.game?.gamelevel?.levelid) 
             retriveGames(bannerData?.game?.gamelevel?.levelid)
             retriveCategories(bannerData?.game?.gamelevel?.gamesubject?.subjectid)
             setSubjectId(bannerData?.game?.gamelevel?.gamesubject?.subjectid)  
            }
          })
        }
        getSubjects().then((data)=>{ 
           if(data.status){
              setSubjectData(data.data)
           } 
        })
     }, []); 

     const retriveCategories=(id)=>{
      getCategories(id)
      .then((data) => { 
          setCategoryData(data?.status ? data.data : []);
      })
      .catch((error) => {
          console.error("Error fetching categories:", error);
          setCategoryData([]);
      });
     }

    const callCategories = (e) => {
         setSubjectIdError(false)
          const value = e.target.value;
          setSubjectId(value);
          setGameData([])
          setCategoryId('');
          setGameId('');
          if (value !== "") {
            retriveCategories(value)
          } else {
              setCategoryData([]);
          }
    };

    const retriveGames=(id)=>{
      getgames(id)
      .then((data) => { 
        setGameData(data?.status ? data.data : []);
      })
      .catch((error) => {
          console.error("Error fetching categories:", error);
          setGameData([]);
      });
    }
    const callGames = (e) => {
        setCategoryIdError(false)
        const value = e.target.value;
        setCategoryId(value);
        setGameId('');
        const selectedCategory = categoryData.find(cat => cat.id === value);
        if (selectedCategory) {
          setCategoryName(selectedCategory.name);
        } else {
          setCategoryName(""); 
        }
        if (value !== "") {
          retriveGames(value)
        } else {
            setGameData([]);
        }
    };
    const handleFileChange = (e) => handleFileValidation(e, setAsset,setAssetError);

    const createformData=()=>{
      const formData = new FormData();
      formData.append('subjectid',subjectId);
      formData.append('categoryid',categoryId);
      formData.append('categoryname',categoryName);
      formData.append('game_id', gameId);
      formData.append('description', description.trim());
      formData.append('campaign_type', campaignType);
      formData.append('picture', asset);
      if(popupType=="EDIT"){
        formData.append('banners_id', bannerId);
      }
      return formData;
    }

    const checkFormValidation =()=>{
      if(!asset && popupType=='CREATE'){
        setAssetError(!asset)   
      } 
      if (!subjectId || !categoryId  || !campaignType  ) {
        setSubjectIdError(!subjectId);
        setCategoryIdError(!categoryId)
        // setGameIdError((categoryName !== 'Static Banner') && (!gameId))
        // setDescriptionError((categoryName !== 'Static Banner') && (!description.trim()))
        setCampaignTypeError(!campaignType) 
        return true;
      }  
      if(!asset && popupType=='CREATE'){
        return true;
      }
      return false;
    }
     const handleSubmit = async (e) => {  
       if(checkFormValidation()){
        return ;
       }
       const formData=createformData();  
       setIsloading(true)
       createBanner(formData).then((Response)=>{ 
        setIsloading(false)
         if(Response.status){    
            toast.success(Response.message) 
            handleClose()
            setTimeout(()=>{
              reRender()
            },500)
            
         }else{
           toast.error(Response.errorMessage)
         } 
       }) 
     };
    
     const handleUpdate = async (e) => {  
      if(checkFormValidation()){
       return ;
      }
      const formData=createformData();  
      setIsloading(true)
      updateBanner(formData).then((Response)=>{ 
       setIsloading(false)
        if(Response.status){  
           toast.success(Response.message) 
           handleClose()
           reRender()
        }else{
          toast.error(Response.errorMessage)
        } 
      }) 
    };
   
     
  return ( 
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <h5 className="modal-title">{`${popupType==='EDIT'?'Update':'Add'} Banner`}</h5>
        </Modal.Header>
        <Modal.Body>
        <form className="row g-3" id="bannerform"  method="post" enctype="multipart/form-data">
            <div className="col-12 px-3">
              <label for="NewGameSubject" className="form-label required">Subject</label>
              <select
                className="form-control"
                onChange={callCategories} 
                value={subjectId}
              >
                 <option value="">--Select Subject--</option>
                {
                    subjectData.map((data)=>{
                        return (<>
                          <option value={data.id}>{data.name}</option>
                        </>)
                    })
                }
              </select>
              <div className="new-banner-subject invalid-feedback" style={{ display: subjectIdError ? 'block' : 'none' }}>Please provide subject.</div>
            </div>
            <div className="col-12 px-3">
              <label for="NewGameBannerCategory" className="form-label required">Category</label>
              <select
                className="form-control"  
                value={categoryId} onChange={callGames}
              >
                 <option value="">--Select Category--</option>
                  {categoryData.map((data)=>{
                    return (<>
                      <option value={data.id}>{data.name}</option>
                    </>)
                  })}
              </select>
              <div className="new-banner-category invalid-feedback" style={{ display: categoryIdError ? 'block' : 'none' }}>Please provide category.</div>
            </div>
          {false && (
            <>
              <div className="col-12 px-3">
                <label htmlFor="NewGameBannerName" className="form-label required">Game Name</label>
                <select
                  id="NewGameBannerName"
                  className="form-control"
                  value={gameId}
                  onChange={(e) => {
                    setGameIdError(false);
                    setGameId(e.target.value);
                  }}
                >
                  <option value="">--Select game--</option>
                  {gameData.map((data) => (
                    <option key={data.id} value={data.id}>{data.name}</option>
                  ))}
                </select>
                <div className="new-banner-name invalid-feedback" style={{ display: gameIdError ? 'block' : 'none' }}>
                  Please provide game name.
                </div>
              </div>

              <div className="col-12 px-3">
                <label htmlFor="NewBannerDescription" className="form-label required">Description</label>
                <input
                  id="NewBannerDescription"
                  type="text"
                  className="form-control"
                  maxLength="250"
                  value={description}
                  onChange={(e) => {
                    setDescriptionError(false);
                    setDescription(e.target.value);
                  }}
                  placeholder="Enter description"
                />
                <div className="new-banner-description invalid-feedback" style={{ display: descriptionError ? 'block' : 'none' }}>
                  Please provide description.
                </div>
              </div>
            </>
          )}
            <div className="col-12 px-3">
              <label for="NewBannerCampaignType" className="form-label required">Campaign Type</label>
              <select className="form-control"  value={campaignType} 
                onChange={(e)=>{setCampaignTypeError(false);setCampaignType(e.target.value)}} >
                <option value="">--Select Campaign type--</option>
                <option value="WEB">Web</option>
                <option value="MOBILE">Mobile</option>
                <option value="TV">TV</option>
              </select>
              <div className="new-banner-campaign-type invalid-feedback" style={{ display: campaignTypeError ? 'block' : 'none' }}>Please provide campaign type.</div>
            </div>   
            <div className="col-12 px-3">
              <label for="NewBannerImage" className="form-label required">Select Banner Image</label>
              <input type="file" className="form-control" 
               onChange={handleFileChange}
               accept=".png, .jpg, .jpeg" />
              <div className="new-banner-image invalid-feedback" style={{ display: assetError ? 'block' : 'none' }}>Please provide image.</div>
              <div className="new-banner-image-validate invalid-feedback">Please provide .png/.jpg/.jpeg format images only.</div>
            </div>     
          </form>   
        </Modal.Body>
        <Modal.Footer>
        <button
                type="button"
                className="btn btn-secondary"
                 onClick={()=>handleClose()}
              >
                Close
              </button>
              <button 
                type="submit"
                className="btn btn-primary"
                disabled={isLoading?true:false}
                onClick={popupType=="CREATE"?handleSubmit:handleUpdate}
              >
                {popupType=="CREATE"?'Upload':'Update'} 
              </button>
        </Modal.Footer>
      </Modal>
       
  );
};

export default CreateBanner;

